import React from 'react';
import { connect } from 'dva';

import { Dispatch } from 'redux';
import Person, { PersonComponentProps } from '../../shared/Person/Person';
import {
  getOnBlur,
  getOnCitizenshipChange,
  getPayload,
  setErrorToRelativeFields,
  trimOnBlur,
} from '../../../helpers/handlers';
import { getSpouse } from '../../../selectors/spouse';
import { MARRIAGE_INFO_FIELD_NAME } from '../../../constants/fieldNames';
import { SPOUSE, APPLICANT } from '../../../constants/modelNames';

const Spouse = function ({
  onChange,
  onCitizenshipChange,
  onBlur,
  handleFIOBlur,
  validatePassportOnBlur,
  ...spouse
}: PersonComponentProps & { validatePassportOnBlur(): void }) {
  return (
    <Person
      person={spouse}
      onChange={onChange}
      onCitizenshipChange={onCitizenshipChange}
      onBlur={(event) => {
        validatePassportOnBlur();
        onBlur(event);
      }}
      children={null}
      model={SPOUSE}
      handleFIOBlur={handleFIOBlur}
    />
  );
};

const mapStateToProps = getSpouse;

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onChange(event) {
    const payload = getPayload(event);
    if (event.target.name === 'birthdate') {
      setErrorToRelativeFields(dispatch, APPLICANT, [
        MARRIAGE_INFO_FIELD_NAME.dateOfMarriage,
      ]);
      dispatch({
        type: `${SPOUSE}/reset/passport/status`,
        payload: { namespace: SPOUSE },
      });
      dispatch({
        type: `${SPOUSE}/reset/issueDate`,
      });
    }
    dispatch({
      type: `${SPOUSE}/onChange`,
      payload,
    });
  },
  validatePassportOnBlur() {
    dispatch({
      type: `${SPOUSE}/passport/validity`,
    });
  },
  onBlur: getOnBlur(SPOUSE, dispatch),
  handleFIOBlur: trimOnBlur(SPOUSE, dispatch),
  onCitizenshipChange: getOnCitizenshipChange(SPOUSE, dispatch),
});
const SpouseContainer = connect(mapStateToProps, mapDispatchToProps)(Spouse);

export { SpouseContainer as Spouse };
